import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SynthService {
    /**
     * Get Home
     * Root endpoint that redirects to login page with token if provided.
     * @param accessToken
     * @returns any Successful Response
     * @throws ApiError
     */
    static getHome(accessToken) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/',
            query: {
                'access_token': accessToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Version
     * Endpoint to return deployment version info -
     *
     * This includes semver information for the jobserver as well as the synth
     * - if connected.
     * @returns DeploymentVersion Successful Response
     * @throws ApiError
     */
    static getVersion() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/version',
        });
    }
    /**
     * Get Orchestrator State
     * Retrieve the current orchestrator state.
     *
     * This is called on load and WS update.
     * @returns SynthesizerStatus Successful Response
     * @throws ApiError
     */
    static getOrchestratorState() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/synthesizer/state',
        });
    }
    /**
     * Get Default Synthesizer Task Configuration
     * @param requestBody
     * @returns SynthesizerTaskConfiguration Successful Response
     * @throws ApiError
     */
    static getDefaultSynthesizerTaskConfiguration(requestBody) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/synthesizer/default',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Synthesizer Configuration
     * Get the currently claimed synthesizer configuration.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getSynthesizerConfiguration(requestBody) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/synthesizer/configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Synthesizer Restart
     * Attempt to restart all orchestrators (allow new jobs).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static synthesizerRestart(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/synthesizer/restart',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Synthesizer Shutdown
     * Attempt to shutdown all orchestrators (don't allow new jobs).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static synthesizerShutdown(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/synthesizer/shutdown',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get App Configuration
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static getAppConfiguration(requestBody) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
